import { v4 as uuidv4, validate as validateUuid } from 'uuid';

/**
 * Generates a new UUID v4 string
 * @returns A new UUID v4 string
 */
export const generateUuid = (): string => {
  return uuidv4();
};

/**
 * Validates if a string is a valid UUID v4
 * @param uuid The string to validate
 * @returns True if the string is a valid UUID v4, false otherwise
 */
export const isValidUuid = (uuid: string): boolean => {
  return validateUuid(uuid);
};
